import React, { createContext, useContext, useState } from 'react';
const defaultFooterHeight = 260;
export const FooterContext = createContext({
    footerHeight: defaultFooterHeight,
    setFooterHeight: () => {
        //placeholder function, do nothing
    }
});
export function useFooterContext() {
    return useContext(FooterContext);
}
export function FooterContextProvider({ children }) {
    const [footerHeight, setFooterHeight] = useState(defaultFooterHeight);
    return (React.createElement(FooterContext.Provider, { value: {
            footerHeight,
            setFooterHeight
        } }, children));
}
//# sourceMappingURL=footer-context.js.map